<template>
    <Link :href="href"
          class="text-gray-900 text-sm font-medium truncate text-left block text-cyan-600 hover:underline">
        <slot></slot>
    </Link>

</template>

<script>
import {Link} from "@inertiajs/vue3";

export default {
    name: "TextLink",
    props: ['href'],
    components: {
        Link
    }
}
</script>

<style scoped>

</style>
